export const defaultColumns = [
  { value: 'protocol_number', label: 'Transação' },
  { value: 'eventable_type', label: 'Tipo' },
  { value: 'details', label: 'Detalhes' },
  { value: 'license_plate', label: 'Placa do Veículo' },
  { value: 'total_amount', label: 'Vlr. Total' },
  { value: 'capture_method', label: 'Método de captura' },
  { value: 'card', label: 'Cartão' },
  { value: 'usage_declaration', label: 'Uso Declarado' },
  { value: 'buyer', label: 'Responsável' },
  { value: 'created_at', label: 'Data e Hora' },
]
